module.exports = __webpack_public_path__ + "media/images/brand/tiktok-003d1e1a4c1971d8035df532eee92fa0.svg";